// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__t+yzq","sk-bouncedelay":"spinner_sk-bouncedelay__11frj","bounce1":"spinner_bounce1__Tfxp1","bounce2":"spinner_bounce2__u98Xc"};